export default __webpack_public_path__ + "static/media/bni.37c1b8fb.jpg";